import useOrganisation from './useOrganisation';
import { formatLocalCurrency, formatLocalNumber, getLocalCurrencySymbol } from '../util';
import { formatDate as formatDateUtil, formatTime as formatTimeUtil } from '../util/time';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';

export default function useOrganisationUtils() {
  const { BaseCurrency, CountryCode } = useOrganisation();

  function getCurrencySymbol(code = BaseCurrency) {
    return getLocalCurrencySymbol(CountryCode, code);
  }

  function formatCurrency(amount, code = BaseCurrency, style = 'currency', options) {
    return formatLocalCurrency(amount, CountryCode, code, style, options);
  }

  function formatCurrencyWithoutSymbol(amount) {
    return formatCurrency(amount, BaseCurrency, 'decimal');
  }

  function formatNumber(number, options) {
    return formatLocalNumber(number, CountryCode, options);
  }

  function formatDate(date, options) {
    const dt = new Date(date);
    dt.setUTCHours(0, 0, 0, 0);

    return formatDateUtil(utcToZonedTime(date, 'UTC'), options);
  }

  function formatTime(date) {
    return formatTimeUtil(utcToZonedTime(date));
  }

  return {
    formatCurrency,
    formatCurrencyWithoutSymbol,
    getCurrencySymbol,
    formatNumber,
    formatDate,
    formatTime,
  };
}
